import React, { useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Stack,
  Typography
} from '@mui/material';
import AndroidIcon from '@mui/icons-material/Android';
import FileCopyIcon from '@mui/icons-material/FileCopy';

export default function AppDownloadQrModal({
  open,
  onClose,
  playStoreUrl,
  qrImageUrl,
  qrSize = 300
}) {
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(playStoreUrl);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Download Questguru for Android</DialogTitle>
      <DialogContent>
        <Stack alignItems="center" spacing={2} sx={{ py: 2 }}>
          <Link
            href={playStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open Questguru in the Google Play Store"
            sx={{ display: 'inline-flex' }}
          >
            <img
              src={qrImageUrl}
              alt="QR code to download Questguru from the Google Play Store"
              style={{
                display: 'block',
                width: `min(${qrSize}px, 72vw)`,
                height: 'auto',
                aspectRatio: '1'
              }}
            />
          </Link>
          <Typography variant="body2" color="text.secondary" align="center">
            Scan with your Android phone to download the Questguru app from Google Play.
          </Typography>
          {copied && <Alert severity="success">Play Store link copied.</Alert>}
          <Button
            startIcon={<FileCopyIcon />}
            onClick={copyLink}
            size="small"
            variant="outlined"
          >
            Copy Play Store Link
          </Button>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button
          component="a"
          href={playStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          startIcon={<AndroidIcon />}
        >
          Open Play Store
        </Button>
      </DialogActions>
    </Dialog>
  );
}
